import { EXTRA_INFRASTRUCTURE_LABELS, INFRASTRUCTURE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';

/** Пункты инфраструктуры: порядок монолита (`Infrastructure.flat_list`), затем флаги, которых у монолита нет */
export function getInfrastructureItems(infrastructure: IBuildingCard['infrastructure']): string[] {
  if (!infrastructure) {
    return [];
  }

  return [...INFRASTRUCTURE_LABELS, ...EXTRA_INFRASTRUCTURE_LABELS]
    .filter(([key]) => infrastructure[key])
    .map(([, label]) => label);
}
